export default {
    title: 'Evaluation criteria',
    current: 'Evaluation criteria assigned to the trend radar',
    locked: 'Since trend evaluations already exist, the evaluation criteria can no longer be exchanged.',
    submit: 'Save',
    tooltip: {
        info: 'Edit evaluation criteria',
        form: 'No longer edit evaluation criteria',
        locked: 'Evaluation criteria can no longer be edited'
    }
}
